enum MicrosEnv {
	ADEV = 'adev',
	STG_EAST = 'stg-east',
	PROD_EAST = 'prod-east',
}

export type Env = 'local' | 'test' | 'production' | 'staging';

const envMap: Record<MicrosEnv | 'local' | 'test' | 'prod' | 'stg', Env> = {
	local: 'local',
	test: 'test',
	prod: 'production',
	stg: 'staging',
	[MicrosEnv.ADEV]: 'staging',
	[MicrosEnv.STG_EAST]: 'staging',
	[MicrosEnv.PROD_EAST]: 'production',
};

const ENV_TO_IDENTITY_ENV: Record<string, 'dev' | 'staging' | 'prod'> = {
	ddev: 'staging',
	test: 'staging',
	local: 'staging',
	staging: 'staging',
	production: 'prod',
	unknown: 'prod',
};

export function getIdentityEnv() {
	return ENV_TO_IDENTITY_ENV[getMappedEnv()] ?? 'staging';
}

export function getEnv(): MicrosEnv | 'local' {
	const appEnv = process.env.APP_ENV;

	if (appEnv) {
		return appEnv as MicrosEnv;
	}

	if (process.env.NODE_ENV === 'development') {
		return 'local';
	}

	// @ts-ignore
	return window.__env__ as MicrosEnv;
}

export function getMappedEnv(): Env {
	return envMap[getEnv()];
}
